const canUseLocalStorage = () => {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    const key = "__storage_probe__";
    window.localStorage.setItem(key, "1");
    window.localStorage.removeItem(key);
    return true;
  } catch (_) {
    return false;
  }
};

export const safeGetItem = (key) => {
  try {
    if (!canUseLocalStorage()) return null;
    return window.localStorage.getItem(key);
  } catch (_) {
    return null;
  }
};

export const safeSetItem = (key, value) => {
  try {
    if (!canUseLocalStorage()) return false;
    window.localStorage.setItem(key, value);
    return true;
  } catch (_) {
    return false;
  }
};

export const safeRemoveItem = (key) => {
  try {
    if (!canUseLocalStorage()) return false;
    window.localStorage.removeItem(key);
    return true;
  } catch (_) {
    return false;
  }
};
